/**
 * Core system identifiers used throughout the application.
 * Add new cores here as they are integrated.
 */
export const CORES = {
  IBS_CODECONNECT: 'ibs-codeconnect'
} as const;

export type CoreIdentifier = typeof CORES[keyof typeof CORES];
